const Star = () => {
	return (<svg width="36" height="50" viewBox="0 0 36 50" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M18 15.3333L22.9374 27.2053L35.752 28.232L25.9894 36.5947L28.9714 49.1013L18 42.4L7.02871 49.1013L10.0107 36.5947L0.248047 28.232L13.0627 27.2053L18 15.3333ZM18 27.483L16.2757 31.6293L11.805 31.9863L15.2117 34.9053L14.1687 39.271L18 36.9307L21.829 39.271L20.7884 34.9077L24.1927 31.9863L19.7244 31.6293L18 27.483ZM8.66671 0.166672V21.1667H4.00005V0.166672H8.66671ZM32 0.166672V21.1667H27.3334V0.166672H32ZM20.3334 0.166672V11.8333H15.6667V0.166672H20.3334Z" />
	</svg>)
}

export default Star